import { render } from "./Tip.vue?vue&type=template&id=301ae520&scoped=true&ts=true"
import script from "./Tip.vue?vue&type=script&lang=ts"
export * from "./Tip.vue?vue&type=script&lang=ts"

import "./Tip.vue?vue&type=style&index=0&id=301ae520&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-301ae520"]])

export default __exports__